import React from 'react'
import './ExportToExcelButton.css'
import { useLanguage } from '../../LanguageProvider';

export default function ExportToExcelButton({ onClick, style }) {
    const { getTranslation } = useLanguage();

    return (
        <div className="export-to-excel-wrapper">

            <div className="export-to-excel-tooltip">
                ?
                <span className="tooltip-text">
                    {getTranslation("exportExcelNote")}
                </span>
            </div>
            <button
                onClick={onClick}
                style={style}
                className="export-to-excel-btn"
            >
                    {getTranslation("exportToExcel")}
            </button>

        </div>
    )
}